<template>
  <div class="piano-control piano-imputed-cost-control row align-items-baseline">
    <div class="col-auto">
      <FormLabel class="section-title" label-is-fake>{{ label }}</FormLabel>
    </div>
    <div class="col">
      <button class="btn btn-primary" type="button" :disabled="libraryImputedCosts.length === value.length" @click.prevent="addCost">Aggiungi costo figurato</button>
    </div>

    <AwlTable v-if="value.length > 0" class="col-12" :heading="headings" :rows="value">
      <template #column-key-actions="{ rowNumber }">
        <ActionDelete :show-icons-only="true" @click="removeCost(rowNumber)" />
      </template>

      <template #column-key-costId="{ value, rowNumber }">
        <FormInputSelect
          :value="value"
          :options="imputedCostsOptions[rowNumber]"
          optionLabel="name"
          optionValue="id"
          @input="updateLibraryCostInCost(rowNumber, $event)"
        />
      </template>

      <template #column-key-totalCost="{ row }">
        <template v-if="row.cost">
          {{ (row.cost.unitCost * row.quantity) | money }}
        </template>
        <span v-else></span>
      </template>

      <template #column-key-quantity="{ row, value, rowNumber }">
        <template v-if="!row.cost">-</template>
        <template v-else>
          <div class="input-group">
            <FormInputText type="number" :min="1" :step="1" :value="value" @input="updateQuantityInCost(rowNumber, $event)" />
            <div class="input-group-append">
              <div class="input-group-text">{{ row.cost.measurementUnit }}</div>
            </div>
          </div>
        </template>
      </template>

      <template #column-key-monthsQuantity="{ row, value, rowNumber }">
        <FormInputMonthlyHoursWidget :total="row.quantity" :value="value" :firstMonth="firstMonth" :lastMonth="lastMonth" @input="updateMonthsQuantityInCost(rowNumber, $event)" />
      </template>
    </AwlTable>
  </div>
</template>

<script>

import formatMoney from '@/filters/formatMoney';

export default {
  name: 'form-input-project-library-costs-widget',
  components: {
    FormLabel: () => import('@/libs/Form/components/FormLabel'),
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete'),
    FormInputText: () => import('@/libs/Form/components/Inputs/FormInputText'),
    FormInputSelect: () => import('@/libs/Form/components/Inputs/FormInputSelect'),
    FormInputMonthlyHoursWidget: () => import('@/views/components/Operative/Form/Widgets/FormInputMonthlyHoursWidget'),
  },
  filters: {
    money: formatMoney,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    libraryImputedCosts: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Costi figurati',
    },
    firstMonth: {},
    lastMonth: {},
  },
  computed: {
    headings () {
      return [
        { key: 'costId', label: 'Costo figurato' },
        { key: 'quantity', label: 'Quantità' },
        { key: 'totalCost', label: 'Costo totale' },
        { key: 'monthsQuantity', label: 'Quantità mensili' },
        { key: 'actions', label: '' },
      ];
    },
    usedImputedCosts () {
      return (this.libraryImputedCosts || []).filter(p => (this.value || []).find(v => v.costId === p.id));
    },
    imputedCostsOptions () {
      return this.value.map((v, i) => {
        return (this.libraryImputedCosts || []).filter(p => {
          return p.id === v.costId || !this.usedImputedCosts.find(up => up.id === p.id);
        });
      });
    },
  },
  methods: {
    addCost () {
      const newValue = [...this.value];
      newValue.push({
        cost: null,
        costId: null,
        quantity: 1,
        monthsQuantity: [],
      });

      this.$emit('input', newValue);
    },
    removeCost (rowNumber) {
      this.$emit('input', (this.value || []).filter((r, i) => i !== rowNumber));
    },
    findCost (costId) {
      return this.libraryImputedCosts.find(c => c.id === costId);
    },
    updateQuantityInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.quantity = parseInt(value) || 0;
        }

        return r;
      }));
    },
    updateLibraryMeasurementUnitInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.measurementUnit = value || null;
        }

        return r;
      }));
    },
    updateMonthsQuantityInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.monthsQuantity = value || [];
        }

        return r;
      }));
    },
    updateLibraryCostInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          const cost = this.findCost(value);

          if (cost) {
            r.costId = value || null;
            r.cost = cost;
          }
        }

        return r;
      }));
    },
  },
};

</script>
